import { IMLThamSoPhongHocMonHoc } from "../../../model/respone/category/IMLThamSoPhongHocMonHoc";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eMLThamSoPhongHocMonHocActionsObj = {
  LOAD_START: undefined,
  LOAD_SUCCESS: {} as IMLThamSoPhongHocMonHoc[],
  LOAD_ERRR: "",

  SHOW_EDIT_MODAL: {} as IMLThamSoPhongHocMonHoc | undefined,
  CLOSE_EDIT_MODAL: undefined,

  SAVE_START: {} as IMLThamSoPhongHocMonHoc,
  SAVE_SUCCESS: undefined,
  SAVE_ERRR: "",

  DELETE_START: 0,
  DELETE_SUCCESS: undefined,
  DELETE_ERRR: "",
};

export const eMLThamSoPhongHocMonHocActionIds = generateActionTypeIds(
  eMLThamSoPhongHocMonHocActionsObj,
  "ML_THAM_SO_PHONG_HOC_MON_HOC"
);
export type IMLThamSoPhongHocMonHocActionTypes = IGenericActionType<
  typeof eMLThamSoPhongHocMonHocActionsObj,
  "ML_THAM_SO_PHONG_HOC_MON_HOC"
>;
